import { HostingTypesWithCloudComplianceBoundaries, HostingTypeToQueryParam, Source } from '@atlassian/mpac-types';
import { appListingLink, encodeAppName } from '@atlassian/mpac-utils';
import { RegulatedSectorAppTilePreferredHosting } from './AppTile.types';
export const mpacHosting = hosting => {
  switch (hosting) {
    case 'cloud':
      return 'cloud';
    case 'server':
      return 'server';
    case 'dataCenter':
      return 'datacenter';
    default:
      {
        console.error('Invalid hosting provided : ' + hosting);
        return '';
      }
  }
};
export const resolveHosting = (tileData, preferredHosting) => {
  if (preferredHosting === RegulatedSectorAppTilePreferredHosting.GovernmentCloud) return HostingTypeToQueryParam[HostingTypesWithCloudComplianceBoundaries.GovernmentCloud];
  const {
    deployments
  } = tileData;
  if (preferredHosting && deployments.includes(preferredHosting)) {
    return mpacHosting(preferredHosting);
  }
  const priorityOrder = ['cloud', 'dataCenter', 'server'];
  const foundDeployment = priorityOrder.find(deployment => deployments.includes(deployment));
  return mpacHosting(foundDeployment) || 'cloud';
};
export const getAppListingUrl = (source, tileData, mountPath, preferredHosting) => {
  // In case of source as PRODUCT, mountPath can have values like '/jira/marketplace'.
  if (source === Source.PRODUCT) {
    return "".concat(mountPath, "/discover/app/").concat(tileData.addonKey);
  }
  const url = appListingLink('').expand({
    appId: tileData.addonId.toString(),
    slug: encodeAppName(tileData.name),
    hosting: resolveHosting(tileData, preferredHosting),
    tab: 'overview'
  });
  return url;
};